import { useEffect, useRef, useState } from 'react';

import type { IFilterBarProps, IFilterPillMenuProps, IFilterPillProps } from '../../../interfaces/globals';
import DropdownMenu from '../DropdownMenu/DropdownMenu';
import './FilterBar.scss';

const FilterBar = ({ disabled = false, className, children }: IFilterBarProps) => {
  const rootClass = ['filter-bar', disabled ? 'filter-bar--disabled' : '', className].filter(Boolean).join(' ');

  return <div className={rootClass}>{children}</div>;
};

export const FilterPill = ({ active = false, className, children, onClick, disabled }: IFilterPillProps) => {
  const rootClass = ['filter-bar__pill', active ? 'filter-bar__pill--active' : '', className].filter(Boolean).join(' ');

  return (
    <button type="button" className={rootClass} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

export const FilterSep = () => <span aria-hidden="true" className="filter-bar__sep" />;

export const FilterPillMenu = ({
  label,
  items,
  placement = 'bottom',
  active = false,
  className
}: IFilterPillMenuProps) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const rootClass = ['filter-bar__pill', 'filter-bar__pill-menu', active ? 'filter-bar__pill--active' : '', className]
    .filter(Boolean)
    .join(' ');

  const wrappedItems = items.map((item) => ({
    ...item,
    onClick: () => {
      item.onClick();
      setOpen(false);
    }
  }));

  return (
    <div ref={ref} className="filter-bar__pill-menu-wrapper">
      <button type="button" className={rootClass} onClick={() => setOpen((prev) => !prev)}>
        {label}
      </button>
      {open && <DropdownMenu items={wrappedItems} placement={placement} />}
    </div>
  );
};

export default FilterBar;
